var map = {
	"./AutocompleteForm.vue": "./src/components/inputs/form/AutocompleteForm.vue",
	"./CheckBoxForm.vue": "./src/components/inputs/form/CheckBoxForm.vue",
	"./DatePicker.vue": "./src/components/inputs/form/DatePicker.vue",
	"./DatePickerForm.vue": "./src/components/inputs/form/DatePickerForm.vue",
	"./FormBuilder.vue": "./src/components/inputs/form/FormBuilder.vue",
	"./HeaderForm.vue": "./src/components/inputs/form/HeaderForm.vue",
	"./LabelForm.vue": "./src/components/inputs/form/LabelForm.vue",
	"./RadioButtonForm.vue": "./src/components/inputs/form/RadioButtonForm.vue",
	"./RangeDatePickerForm.vue": "./src/components/inputs/form/RangeDatePickerForm.vue",
	"./RichtextForm.vue": "./src/components/inputs/form/RichtextForm.vue",
	"./SchemeForm.vue": "./src/components/inputs/form/SchemeForm.vue",
	"./SelectForm.vue": "./src/components/inputs/form/SelectForm.vue",
	"./SignForm.vue": "./src/components/inputs/form/SignForm.vue",
	"./SubHeaderForm.vue": "./src/components/inputs/form/SubHeaderForm.vue",
	"./SwitchForm.vue": "./src/components/inputs/form/SwitchForm.vue",
	"./TableForm.vue": "./src/components/inputs/form/TableForm.vue",
	"./TextAreaForm.vue": "./src/components/inputs/form/TextAreaForm.vue",
	"./TextForm.vue": "./src/components/inputs/form/TextForm.vue",
	"./UploadFileForm.vue": "./src/components/inputs/form/UploadFileForm.vue",
	"./UploadForm.vue": "./src/components/inputs/form/UploadForm.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/inputs/form sync \\.(js%7Cvue)$/";